'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var ElectricalCar = function (_React$Component) {
    _inherits(ElectricalCar, _React$Component);

    function ElectricalCar() {
        _classCallCheck(this, ElectricalCar);

        return _possibleConstructorReturn(this, (ElectricalCar.__proto__ || Object.getPrototypeOf(ElectricalCar)).apply(this, arguments));
    }

    _createClass(ElectricalCar, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M7.302 9.284v-2.01c0-.28-.23-.51-.51-.51s-.508.23-.508.51v2.01c-.89.23-1.526 1.018-1.526 1.984v3.282h.738v1.476c0 .28.23.51.51.51s.508-.23.508-.51V14.55h.56v1.476c0 .28.23.51.51.51s.508-.23.508-.51V14.55h.738v-3.282c0-.94-.636-1.755-1.526-1.984zm.508 1.984v2.264H5.75v-2.264c0-.56.457-1.018 1.017-1.018s1.043.458 1.043 1.018z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M25.365 18.595c-.407-2.137-1.96-2.697-3.943-3.155-1.857-.458-3.41-1.272-4.885-2.035-2.137-1.12-4.147-2.188-6.92-2.188v1.016c2.52 0 4.427 1.02 6.437 2.087 1.552.814 3.155 1.654 5.114 2.137 2.24.534 2.926 1.043 3.18 2.366.178.89-.076 1.806-.66 2.417-.23.254-.46.382-.637.382h-.075c-.254-1.476-1.526-2.62-3.078-2.62s-2.8 1.094-3.053 2.595h-8.37c-.254-1.476-1.526-2.62-3.078-2.62-1.4 0-2.595.916-2.977 2.188-.84-.51-1.4-1.425-1.4-2.468v-2.595c0-1.832 1.272-3.358 2.977-3.765v-1.043C1.733 11.7.003 13.71.003 16.102v2.595c0 1.577.94 2.926 2.264 3.562.076 1.653 1.45 2.976 3.13 2.976 1.55 0 2.823-1.145 3.077-2.62h8.37c.254 1.476 1.526 2.62 3.078 2.62s2.824-1.145 3.078-2.62h.076c.458 0 .916-.23 1.374-.687.814-.866 1.145-2.113.916-3.334zm-19.97 5.597c-1.17 0-2.113-.94-2.113-2.112s.94-2.112 2.112-2.112 2.112.94 2.112 2.112-.94 2.112-2.112 2.112zm14.525 0c-1.17 0-2.112-.94-2.112-2.112s.94-2.112 2.112-2.112 2.112.94 2.112 2.112-.94 2.112-2.112 2.112z' })
            );
        }
    }]);

    return ElectricalCar;
}(_react2.default.Component);

ElectricalCar.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = ElectricalCar;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/electrical-car.js
// module id = 1096
// module chunks = 0